const SettingsConstants = {
  tabs: [
    { name: "general", title: "Profile", description: "Manage your profile.", component: "SettingsAreaProfile" },
    { name: "password", title: "Password", description: "Manage your password. Make sure to always use a unique password.", component: "SettingsAreaPassword" },
    { name: "email", title: "Email notifications", description: "Manage your preferences regarding the emails you get from Cofocus.", component: "SettingsAreaEmail" },
    { name: "privacy", title: "Privacy", description: "Manage who you have taken a break from, for how long and who you have blocked.", component: "SettingsAreaPrivacy" },
    { name: "notifications", title: "Notifications", description: "Manage your notifications for sessions.", component: "SettingsAreaNotifications" },
    { name: "integrations", title: "Integrations", description: "Manage what other apps Cofocus connects to.", component: "SettingsAreaIntegrations" },
    { name: "billing", title: "Billing", description: "Manage your subscription plan and view your billing history.", component: "SettingsAreaBilling" },
    { name: "danger", title: "Danger zone", description: "Learn more about how to delete your account.", component: "SettingsAreaDanger" },
  ],

  integrations: [
    {
      name: "Google Calendar",
      app: "googleCalendar",
      icon: "IconGoogleCalendar",
      connected: false,
      info: "Sync Cofocus with your Google Calendar to have your sessions show up in your personal calendar.",
    },
  ],
};

export default SettingsConstants;
